import { inject } from '@angular/core';
import {
  GetClinicInfoDataResult,
  QRCodesService,
} from '@anihis/core/data-access';
import {
  patchState,
  signalStore,
  withMethods,
  withState,
  withHooks,
} from '@ngrx/signals';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap, first } from 'rxjs/operators';
import { LoadingStatus } from '../../../shared/enums/loading';
import { ActivatedRoute } from '@angular/router';

type QrCodeInfoState = {
  data: GetClinicInfoDataResult | undefined;
  status: LoadingStatus | undefined;
};

const initialState: QrCodeInfoState = {
  data: undefined,
  status: undefined,
};

export const QrCodeInfoStore = signalStore(
  withState(initialState),
  withMethods(
    (
      store,
      qRCodesService = inject(QRCodesService),
      activatedRoute = inject(ActivatedRoute),
    ) => {
      return {
        fetchData() {
          patchState(store, { status: LoadingStatus.Loading });

          return activatedRoute.url.pipe(
            first(),
            map((segments) => segments[segments.length - 1]?.path),
            switchMap((clientId) => this.fetchQrInfo(clientId)),
            catchError((err) => {
              patchState(store, { status: LoadingStatus.Loaded });
              return of();
            }),
          );
        },

        fetchQrInfo(clientId: string) {
          patchState(store, { status: LoadingStatus.Loading });
          return qRCodesService.qRCodesClinicUidGet(clientId).pipe(
            tap((result) => {
              patchState(store, {
                data: result,
                status: LoadingStatus.Loaded,
              });
            }),
            catchError((err) => {
              patchState(store, { status: LoadingStatus.Loaded });
              return of();
            }),
          );
        },
      };
    },
  ),
  withHooks({
    onInit(store) {
      store.fetchData().subscribe();
    },
  }),
);
